import { useState, useEffect } from "react";
import { ReserBusinessSource, ReservationPMSDetails, SaveReserBusinessSource } from "../../Services/Service";

import swal from "sweetalert";
import ReservationSidebar from "../Commun/ReservationSidebar";
import ReservationHeader from "../Commun/ReservationHeader";
import { useProperty } from "../../PropertyContext";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import '../Booking Details/BookingList.css';
import '../Agent Details/AgentList.css';

export const ReservationBusinessSource = () => {
    const { selectedProperty } = useProperty();
    const [businessSources, setBusinessSources] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([{ code: "", name: "" }]);
    const [searchTerm, setSearchTerm] = useState("");
    const [results, setResults] = useState([]);
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    useEffect(() => {
        const fetchBusinessSource = async () => {
            setLoading(true);
            try {
                const data = await ReserBusinessSource(selectedProperty?.PropertyID);
                if (Array.isArray(data)) setBusinessSources(data);
            } catch (error) {
                console.log("Error fetching business sources:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBusinessSource();
    }, [selectedProperty]);


    const handleAddRow = () => {
        setRows([...rows, { code: "", name: "" }]);
    };

    const handleDeleteRow = (index) => {
        setRows(rows.filter((_, i) => i !== index));
    };



    const handleChange = (index, field, value) => {
        const newRows = [...rows];
        newRows[index][field] = value;
        setRows(newRows);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            for (let row of rows) {
                if (!row.code || !row.name) {
                    swal("Please Enter Code and Business Source !", {
                        icon: "warning",
                        buttons: {
                            confirm: { text: "OK", className: "btn btn-warning" },
                        },
                    });
                    setLoading(false);
                    return; // Stop execution
                }
            }
            // Loop through all rows and send each one to the API
            for (let row of rows) {
                const formdata = {
                    ID: 0, // or whatever ID you need
                    Code: row.code,
                    BusinessSource: row.name,
                    ProfileID: row.sourceId || "",
                    ProfileName: row.sourceCode || "",
                    PropID: selectedProperty?.PropertyID,
                };

                console.log("formdata", formdata)

                await SaveReserBusinessSource(formdata);
            }

            swal("Business Source Added Successfully", {
                icon: "success",
                buttons: {
                    confirm: { text: "OK", className: "btn btn-success" },
                },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("Add-Business-Source")
                );
                modal.hide();
            });

            // Reset rows
            setRows([{ code: "", name: "" }]);

            // Refresh the list
            const data = await ReserBusinessSource(selectedProperty?.PropertyID);
            if (Array.isArray(data)) setBusinessSources(data);

        } catch (error) {
            console.log("Error saving Business Source", error);
            alert("Failed to save Business Source");
        } finally {
            setLoading(false);
        }
    };


    const [editData, setEditData] = useState({
        ID: 0,
        Code: "",
        BusinessSource: "",
        ProfileID: "",
        ProfileName: "",
        PropID: selectedProperty?.PropertyID,

    });


    const handleUpdate = async () => {
        setLoading(true);
        try {
            await SaveReserBusinessSource(editData); // ID is included

            swal("Business Source Updated Successfully", {
                icon: "success",
                buttons: { confirm: { text: "OK", className: "btn btn-success" } },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("Update-Business-Source")
                );
                if (modal) modal.hide();
            });

            // Refresh the list
            const data = await ReserBusinessSource(selectedProperty?.PropertyID);
            if (Array.isArray(data)) setBusinessSources(data);

        } catch (error) {
            console.log("Error updating Business Source", error);
            alert("Failed to update Business Source");
        } finally {
            setLoading(false);
        }
    };


    const handlePMSDetailSearch = async (e) => {
        e.preventDefault();
        if (!searchTerm.trim()) return;

        try {
            setLoading(true);

            const res = await ReservationPMSDetails(searchTerm, "Source", selectedProperty?.PropertyID); // passing Name + ProfileType

            const profiles = res?.Result?.profileSummaries?.profileInfo || [];
            setResults(profiles);
        } catch (error) {
            console.error("Search error:", error);
        } finally {
            setLoading(false);
        }
    };


    // const handleSelectAgent = (item) => {
    //     const selectedName = item.profile?.formerName?.fullName || "";
    //     const profileId = item.profileIdList?.[0]?.id || "";

    //     const updatedRows = [...rows];

    //     updatedRows[selectedRowIndex] = {
    //         ...updatedRows[selectedRowIndex],
    //         sourceCode: selectedName,
    //         sourceId: profileId,
    //     };

    //     setRows(updatedRows);

    //     // Reset Search Input & Table Data
    //     setSearchTerm("");
    //     setResults([]);

    //     // Search Modal Close
    //     const searchModalEl = document.getElementById("SearchAgentModal");
    //     const searchModal = window.bootstrap.Modal.getInstance(searchModalEl);

    //     if (searchModal) {
    //         searchModal.hide();
    //     }

    //     // Parent Modal Reopen
    //     setTimeout(() => {
    //         const parentModalEl = document.getElementById("Add-Business-Source");

    //         const parentModal =
    //             window.bootstrap.Modal.getInstance(parentModalEl) ||
    //             new window.bootstrap.Modal(parentModalEl);

    //         parentModal.show();
    //     }, 300);
    // };


    const handleSelectAgent = (item) => {
        const selectedName =
            item.profile?.formerName?.fullName || "";

        const profileId =
            item.profileIdList?.[0]?.id || "";

        if (isEditMode) {

            setEditData(prev => ({
                ...prev,
                ProfileID: profileId,
                ProfileName: selectedName,
            }));

        } else {

            const updatedRows = [...rows];

            updatedRows[selectedRowIndex] = {
                ...updatedRows[selectedRowIndex],
                sourceCode: selectedName,
                sourceId: profileId,
            };

            setRows(updatedRows);
        }

        setSearchTerm("");
        setResults([]);

        const searchModalEl =
            document.getElementById("SearchAgentModal");

        const searchModal =
            window.bootstrap.Modal.getInstance(searchModalEl);

        if (searchModal) {
            searchModal.hide();
        }

        setTimeout(() => {

            const modalId = isEditMode
                ? "Update-Business-Source"
                : "Add-Business-Source";

            const parentModalEl =
                document.getElementById(modalId);

            const parentModal =
                window.bootstrap.Modal.getInstance(parentModalEl) ||
                new window.bootstrap.Modal(parentModalEl);

            parentModal.show();

        }, 300);
    };

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card booking-list-card agent-list-card">
                                        <div className="card-header ">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h4 className="card-title mb-0">Business Source List</h4>
                                                <button type="button" className="btn btn-primary btn-sm waves-effect waves-light mt-1" data-bs-toggle="modal" data-bs-target="#Add-Business-Source">Add </button>
                                            </div>
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive booking-list-table-wrap agent-list-table-wrap">

                                                {/* <table
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>Code</th>
                                                            <th>Business Source</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {businessSources && businessSources.length > 0 ? (
                                                            businessSources.map((item, index) => (
                                                                <tr key={item.ID || index}>
                                                                    <td>{item.Code}</td>
                                                                    <td>{item.BusinessSource}</td>
                                                                    <td>
                                                                        <button type="button" className="btn btn-primary btn-sm waves-effect waves-light py-1 px-2" data-bs-toggle="modal" data-bs-target="#Update-Business-Source"
                                                                            onClick={() => setEditData({
                                                                                ID: item.ID,
                                                                                Code: item.Code,
                                                                                BusinessSource: item.BusinessSource,
                                                                                PropID: item.PropID ?? selectedProperty?.PropertyID ?? 0,
                                                                            })}><i className="fas fa-edit"></i></button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center">
                                                                    No data found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table> */}

                                                <DataTable
                                                    value={businessSources}
                                                    className="p-datatable-bordered agent-list-table"
                                                    paginator
                                                    rows={10}
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    showGridlines
                                                    stripedRows
                                                    responsiveLayout="scroll"
                                                    filterDisplay="row"
                                                    emptyMessage="No data found"
                                                >
                                                    <Column
                                                        field="Code"
                                                        header="Code"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search Code"
                                                    />
                                                    <Column
                                                        field="BusinessSource"
                                                        header="Business Source"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search Business Source"
                                                    />

                                                    <Column
                                                        field="ProfileID"
                                                        header="Source ID"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search Source ID"
                                                    />


                                                    <Column
                                                        field="ProfileName"
                                                        header="Source Name"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search Source Name"
                                                    />

                                                    <Column
                                                        header="Action"
                                                        body={(rowData) => (

                                                            <Button
                                                                type="button"
                                                                icon="pi pi-pencil"
                                                                className="p-button-sm p-button-text  me-2"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#Update-Business-Source"
                                                                onClick={() =>
                                                                    setEditData({
                                                                        ID: rowData.ID,
                                                                        Code: rowData.Code,
                                                                        BusinessSource: rowData.BusinessSource,
                                                                        ProfileID: rowData.ProfileID,
                                                                        ProfileName: rowData.ProfileName,
                                                                        PropID: rowData.PropID ?? selectedProperty?.PropertyID ?? 0,
                                                                    })
                                                                }
                                                            />
                                                        )}
                                                    />
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* sumbit Business Source modal content */}
                    <div
                        id="Add-Business-Source"
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Add Business Source</h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body" style={{ maxHeight: "460px", overflowY: "auto" }}>
                                    <table className="table table-bordered ">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "152px" }}>Code</th>
                                                <th>Business Source</th>
                                                <th>Opera Source</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map((row, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Code"
                                                            value={row.code}
                                                            onChange={(e) =>
                                                                handleChange(index, "code", e.target.value)
                                                            }
                                                            name="code[1,2,3,5]"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Business Source"
                                                            value={row.name}
                                                            onChange={(e) =>
                                                                handleChange(index, "name", e.target.value)
                                                            }
                                                        />
                                                    </td>
                                                    <td>
                                                        <div className="d-flex">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter Source Code"
                                                                value={row.sourceCode || ""}
                                                                onChange={(e) =>
                                                                    handleChange(index, "sourceCode", e.target.value)
                                                                }
                                                                readOnly
                                                            />

                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-sm mx-2"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#SearchAgentModal"
                                                                onClick={() => {
                                                                    setSelectedRowIndex(index);
                                                                    setIsEditMode(false);

                                                                    // Parent modal temporarily hide
                                                                    const parentModal = window.bootstrap.Modal.getInstance(
                                                                        document.getElementById("Add-Business-Source")
                                                                    );

                                                                    if (parentModal) {
                                                                        parentModal.hide();
                                                                    }
                                                                }}
                                                            >
                                                                <i className="fas fa-search"></i>
                                                            </button>
                                                        </div>
                                                    </td>


                                                    <td className="text-center">
                                                        {index !== 0 && (
                                                            <button
                                                                className="btn btn-sm text-danger fs-6"
                                                                onClick={() => handleDeleteRow(index)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="text-end">
                                        <button className="btn btn-sm btn-primary" onClick={handleAddRow}>
                                            Add
                                        </button>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-info waves-effect waves-light"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* /.modal */}

                    {/* update Business */}
                    <div
                        id="Update-Business-Source"
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Update Business Source</h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>

                                <div className="modal-body" >
                                    <div className="mb-3">
                                        <label className="form-label">Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editData.Code}
                                            onChange={(e) => setEditData({ ...editData, Code: e.target.value })}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Business Source</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editData.BusinessSource}
                                            onChange={(e) => setEditData({ ...editData, BusinessSource: e.target.value })}
                                        />
                                    </div>



                                    <div className="mb-3">
                                        <label className="form-label">Opera Source</label>
                                        <div className="d-flex ">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={editData.ProfileName || ""}
                                                readOnly
                                            />

                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm mx-2"
                                                data-bs-toggle="modal"
                                                data-bs-target="#SearchAgentModal"
                                                onClick={() => {
                                                    setIsEditMode(true);

                                                    const parentModal = window.bootstrap.Modal.getInstance(
                                                        document.getElementById("Update-Business-Source")
                                                    );

                                                    if (parentModal) {
                                                        parentModal.hide();
                                                    }
                                                }}
                                            >
                                                <i className="fas fa-search"></i>
                                            </button>
                                        </div>
                                    </div>


                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-info waves-effect waves-light"
                                        onClick={handleUpdate}
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* pms Sratch */}
                    <>
                        {/*  Large modal example */}
                        <div
                            className="modal fade"
                            id="SearchAgentModal"
                            tabIndex="-1"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="myLargeModalLabel">
                                            Search Opera Source
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className='row'>
                                            <div className='col-ms-12'>
                                                <form className='row' onSubmit={handlePMSDetailSearch}>
                                                    <div className='col-md-4'>
                                                        <div className='mb-3'>
                                                            <input type='text' className='form-control' placeholder="Search here..." value={searchTerm}
                                                                onChange={(e) => setSearchTerm(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-1'>
                                                        <div className='mb-3'>
                                                            <button type='submit' className='btn btn-primary '>Search</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-12'>

                                                <div className='table-responsive'>
                                                    <table className='table '>
                                                        <thead>
                                                            <tr>
                                                                <th>Sr #</th>
                                                                <th>Name</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {results.length > 0 ? (
                                                                results.map((item, index) => (
                                                                    <tr key={item.profileIdList?.[0]?.id || index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{item.profile?.formerName?.fullName}</td>
                                                                        <td>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-primary"
                                                                                onClick={() => handleSelectAgent(item)}
                                                                            >
                                                                                Select
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="3" className="text-center">
                                                                        {loading
                                                                            ? "Searching..."
                                                                            : "No results. Please search other agent."}
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                {/* /.modal-content */}
                            </div>
                            {/* /.modal-dialog */}
                        </div>

                        {/* /.modal */}
                    </>

                </div>

            </div>
        </>
    )
}
